// Formas e utilidades compartilhadas pela decoração de festas (selo, modal, login)
export const STAR_PATH = 'M0 -11 L3 -3.6 L11 -3.4 L4.8 1.6 L7 9.6 L0 5 L-7 9.6 L-4.8 1.6 L-11 -3.4 L-3 -3.6 Z';
export const SPARKLE_PATH = 'M0 -11 C1 -2.6 2.6 -1 11 0 C2.6 1 1 2.6 0 11 C-1 2.6 -2.6 1 -11 0 C-2.6 -1 -1 -2.6 0 -11 Z';

// Primeiro nome com a capitalização de sempre, mesmo com o cadastro todo em maiúsculas ("GABRIEL" -> "Gabriel")
export function firstNameOf(name) {
    const first = (name || '').trim().split(/\s+/)[0] || '';
    return first.toLocaleLowerCase('pt-BR').split('-')
        .map(part => part.charAt(0).toLocaleUpperCase('pt-BR') + part.slice(1)).join('-');
}
